/*************************************************/
/* HEADER                                        */
/*************************************************/

export function header(body) {
    let headerElement,
        scrollTimer;

    const headerStickyClass = 'header-sticky';
    const megaMenuItemToggleSelector = '.mega-menu__item-level-toggle';
    const megaMenuSelector = '.mega-menu';
    const megaMenuActiveClass = 'active';
    const megaMenuItemParentSelector = '.mega-menu__item--parent';
    const megaMenuDismissButtonSelector = '.mega-menu__dismiss-button';
    const megaMenuItemParentLinkSelector = '.mega-menu__link.mega-menu__link--parent';
    const menuNavParentItemSelector = '.menu-nav__item--w-dropdown';
    const megaMenuOpenClass = "menu-nav__item--mega-menu-open";
    const events = ['click', 'keyup']


    function closeMegaMenu() {
        const activeMegaMenus = document.querySelectorAll(`${megaMenuSelector}.${megaMenuActiveClass}`);
        if (activeMegaMenus) {
            activeMegaMenus.forEach(menu => {
                menu.classList.remove(megaMenuActiveClass);
            });
        }

        const activeMegaMenuItems = document.querySelectorAll(`${megaMenuItemParentSelector}.${megaMenuActiveClass}`);
        if (activeMegaMenuItems) {
            activeMegaMenuItems.forEach(item => {
                item.classList.remove(megaMenuActiveClass);
            });
        }

        const megaMenuParentItems = document.querySelectorAll(menuNavParentItemSelector);
        if (megaMenuParentItems) {
            megaMenuParentItems.forEach(megaMenuParent => {
                megaMenuParent.classList.remove(megaMenuOpenClass);
            })
        }

        // menuNavParents.removeClass(megaMenuOpenClass);
    }

    const setStickyHeader = () => {
        const top = window.pageYOffset || document.documentElement.scrollTop
        if (top > headerElement.offsetHeight / 2) {
            body.classList.add(headerStickyClass);
        } else {
            body.classList.remove(headerStickyClass);
        }
    }


    const init = function () {
        headerElement = document.querySelector('.header');

        // Sticky header
        setStickyHeader();
        window.addEventListener('scroll', e => {
            clearTimeout(scrollTimer);
            scrollTimer = setTimeout(function () {
                setStickyHeader();
            }, 10);
        });

        //Mega menu
        const megaMenuParentItems = document.querySelectorAll(menuNavParentItemSelector);
        if (megaMenuParentItems) {
            megaMenuParentItems.forEach(menuNavParent => {
                events.forEach(eventName => {
                    menuNavParent.addEventListener(eventName, e => {
                        if ((e.target.classList.contains('menu-nav__item--w-dropdown') || e.target.classList.contains('menu-nav__link--w-dropdown'))  && (eventName == "click" || (eventName == "keyup" && e.key === "Enter"))) {
                            e.stopPropagation();
                            e.preventDefault();
                            if (!menuNavParent.classList.contains(megaMenuOpenClass)) {
                                closeMegaMenu();
                                menuNavParent.classList.add(megaMenuOpenClass);
                            } else {
                                menuNavParent.classList.remove(megaMenuOpenClass);
                            }
                        }
                    });
                });
            })
        }

        //Mega menu items
        const megaMenuItemToggles = document.querySelectorAll(megaMenuItemToggleSelector);
        if (megaMenuItemToggles) {
            megaMenuItemToggles.forEach(toggle => {
                toggle.addEventListener('click', e => {
                    e.stopPropagation();
                    e.preventDefault();
                    const siblings = toggle.closest(megaMenuSelector)?.querySelectorAll(`${megaMenuSelector}.${megaMenuActiveClass}`);
                    const siblingsParents = toggle.closest(megaMenuSelector)?.querySelectorAll(`${megaMenuItemParentSelector}.${megaMenuActiveClass}`);
                    if (siblings) {
                        siblings.forEach(menu => {
                            menu.classList.remove(megaMenuActiveClass);
                        });
                    }
                    if (siblingsParents) {
                        siblingsParents.forEach(parent => {
                            parent.classList.remove(megaMenuActiveClass);
                        });
                    }

                    const toggleParent = toggle.closest(megaMenuItemParentSelector);
                    toggleParent.classList.toggle(megaMenuActiveClass);
                    toggleParent.querySelector(megaMenuSelector).classList.toggle(megaMenuActiveClass);
                });
            });
        }

        const megaMenuLinkItems = document.querySelectorAll(megaMenuItemParentLinkSelector);
        if (megaMenuLinkItems) {
            megaMenuLinkItems.forEach(link => {
                link.addEventListener('click', e => {
                    e.stopPropagation();
                    e.preventDefault();
                    link.nextElementSibling.click();
                })
            });
        }

        const megaMenuDismissButton = document.querySelectorAll(megaMenuDismissButtonSelector);
        if (megaMenuDismissButton) {
            megaMenuDismissButton.forEach(dismissButton => {
                dismissButton.addEventListener('click', e => {
                    closeMegaMenu();
                });
            });
        }

        body.addEventListener('click', e => {
            
            if(!e.target.classList.toString().includes('mega-menu')){
                closeMegaMenu();
            }

        });
    };

    init();

}

